"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectIntegrationPage = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const ApiKeyComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/ApiKeyComponent");
const constants_1 = require("src/hello_assets/src/constants");
const ProjectIntegrationPage = ({}) => {
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const projectsState = projectsContext.projectsState;
    const onClickReload = async () => {
        projectsContext.fetchAllProjects();
    };
    const isWarning = !projectsContext.getProjectData(projectApiKey).state.hasData;
    const warningTitle = "SDK not integrated";
    const warningMessage = "Please integrate the SDK and send your first event!";
    const successTitle = "SDK integrated!";
    const successMessage = React.createElement(React.Fragment, null,
        "You can now add another data source or ",
        React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.home(projectApiKey) },
            React.createElement("u", null, "explore your data")));
    const warningInstructions = React.createElement(React.Fragment, null,
        React.createElement("p", null,
            React.createElement("a", { href: AppRouting_1.AppPathGenerator.github.home(), target: "_blank", rel: "noreferrer" },
                React.createElement("u", null, "Here")),
            " you can find the SDK"),
        React.createElement("p", null,
            "If you have any questions, join our ",
            React.createElement("a", { href: constants_1.URL_DISCORD, target: "_blank" },
                React.createElement("u", null, "discord")),
            "."));
    const successInstructions = React.createElement(React.Fragment, null,
        React.createElement("p", null,
            React.createElement("a", { href: AppRouting_1.AppPathGenerator.github.home(), target: "_blank", rel: "noreferrer" },
                React.createElement("u", null, "Here")),
            " you can find the SDK"),
        React.createElement("p", null,
            "If you have any questions, join our ",
            React.createElement("a", { href: constants_1.URL_DISCORD, target: "_blank" },
                React.createElement("u", null, "discord")),
            "."));
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.PageHeader, { title: "Integration", extra: React.createElement(antd_1.Button, { icon: React.createElement(icons_1.ReloadOutlined, null), onClick: onClickReload, disabled: projectsState.inProgress, loading: projectsState.inProgress }) }),
        React.createElement(PageContent_1.default, null,
            React.createElement(PageContent_1.default.Card, null,
                isWarning ?
                    React.createElement(antd_1.Alert, { message: warningTitle, description: warningMessage, type: "warning", showIcon: true })
                    :
                        React.createElement(antd_1.Alert, { message: successTitle, description: successMessage, type: "success", showIcon: true }),
                React.createElement("div", { style: { marginTop: "16px" } }, isWarning ?
                    React.createElement(React.Fragment, null,
                        React.createElement(antd_1.Typography.Paragraph, null,
                            React.createElement(ApiKeyComponent_1.ApiKeyComponent, { value: projectApiKey })),
                        React.createElement(antd_1.Typography.Paragraph, null, warningInstructions)) :
                    React.createElement(React.Fragment, null,
                        React.createElement(antd_1.Typography.Paragraph, null,
                            React.createElement(ApiKeyComponent_1.ApiKeyComponent, { value: projectApiKey })),
                        React.createElement(antd_1.Typography.Paragraph, null, successInstructions))))));
};
exports.ProjectIntegrationPage = ProjectIntegrationPage;
